var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C16.1336 2 19.5339 5.13515 19.9551 9.15723C21.1434 9.55629 22 10.6773 22 12V14C22 17.866 18.866 21 15 21C14.9129 21 14.8286 20.9877 14.748 20.9668C14.4382 21.5257 13.8707 21.9217 13.2041 21.9893L13 22H12L11.7959 21.9893C10.7872 21.887 10 21.0357 10 20C10 18.8954 10.8954 18 12 18H13C13.7534 18 14.409 18.4169 14.75 19.0322C14.83 19.0116 14.9136 19 15 19C16.6357 19 18.0878 18.2143 19 17C17.8954 17 17 16.1046 17 15V11C17 10.2779 17.3834 9.64653 17.957 9.29492C17.6079 6.31358 15.0751 4 12 4C8.92486 4 6.39104 6.31353 6.04199 9.29492C6.61597 9.64644 7 10.2776 7 11V15C7 16.1046 6.10457 17 5 17C3.34315 17 2 15.6569 2 14V12C2 10.6776 2.85612 9.55655 4.04395 9.15723C4.46505 5.1351 7.86637 2 12 2ZM5 11C4.44772 11 4 11.4477 4 12V14C4 14.5523 4.44772 15 5 15V11ZM19 15C19.5523 15 20 14.5523 20 14V12C20 11.4477 19.5523 11 19 11V15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.22eb94ab451ae82d0ce5b50f905edd35.svg";
export { ForwardRef as ReactComponent };